export enum DistributionType {
	ALL = "ALL",
	STRUCTURED_DISTRIBUTION = "STRUCTURED_DISTRIBUTION",
	DATABASE = "DATABASE",
}
